import getCdnUrl from '../../../helpers/get-cdn-url';

const SiiLogo = getCdnUrl('/common_assets/assets/images/sii_logo.png');

export default SiiLogo;
